import { theme } from 'antd'
import { ThemeConfig } from 'antd/lib/config-provider/context'

// Full WF dark theme: creators see content the way students do.
export const THEME: ThemeConfig = {
    algorithm: theme.darkAlgorithm,
    token: {
        colorPrimary: '#6e85c4', // WF periwinkle — the accent WF uses on dark
        colorPrimaryHover: '#b3c7fe', // WF lightenColorFive
        colorLink: '#9db0e6',
        colorSuccess: '#52c41a',
        colorWarning: '#faad14',
        colorError: '#f5222d',
        fontSize: 16,
        colorBgBase: '#1b202c', // WF card ground; body sits lighter at #333a4b
        borderRadius: 6,
        boxShadow:
            '0 0.1875rem 0.375rem -0.25rem rgba(0, 0, 0, 0.12), 0 0.375rem 1rem 0 rgba(0, 0, 0, 0.08), 0 0.5625rem 1.75rem 0.5rem rgba(0, 0, 0, 0, 0.05)',
        fontFamily: "Montserrat, 'DejaVu Sans', Verdana, sans-serif",
    },
}
